export const MODAL_NAMES = {
  BLOCKED_ACCOUNT_INFO: 'BLOCKED_ACCOUNT_INFO',
  INVITATION_SUCCESS: 'INVITATION_SUCCESS',
  PAYMENT_PROBLEM_INFO: 'PAYMENT_PROBLEM_INFO',
  PERMISSIONS_INFO: 'PERMISSIONS_INFO',
  SUBSCRIPTION_CANCEL_CONFIRM: 'SUBSCRIPTION_CANCEL_CONFIRM',
  SUBSCRIPTION_CANCEL_INFO: 'SUBSCRIPTION_CANCEL_INFO',
  SUBSCRIPTION_CREATE_SUCCESS: 'SUBSCRIPTION_CREATE_SUCCESS',
};
